import "./App.css";
import PublicRoute from "./routes/public-route";
function App() {
  return (
    <div className="App">
     <PublicRoute/>
    </div>
  );
}

export default App;
